// extracted by mini-css-extract-plugin
module.exports = {"container":"TimerMessage_container__3wTO-"};